// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  donationPageDetails: Object,
};

const DeleteDonationPage = (props: Props) => {
  const {
    visible,
    close,
    submit,
    donationPageDetails,
  } = props;

  const deleteSelectedPaymentPage = () => {
    submit(donationPageDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">No, dont deactivate</SpButton>,
        <SpButton onClick={deleteSelectedPaymentPage} type="danger">Yes, deactivate</SpButton>,
      ]}
      title="Deactivate Donation Page"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this Donation Page?</h6>
        <SpH5 className="pb-3">
          <div>{donationPageDetails.title ? donationPageDetails.title : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteDonationPage;
